<template>
  <el-tag class="component--tag" :closable="closable" @close="handleClose">
    <span class="compare-ref-class" ref="compareRef"></span>
    <span class="content-wrapper" :style="{'max-width':contentMaxWidth+'px'}" ref="contentWrapper">
      <slot></slot>
    </span>
  </el-tag>
</template>

<script>
export default {
  props: {
    closable: {
      type: Boolean,
      default: false
    },
    contentMaxWidth: {
      type: Number,
      default: 120
    }
  },
  data() {
    return {};
  },
  methods: {
    handleClose() {
      this.$emit("close");
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.$refs.compareRef.innerHTML = this.$refs.contentWrapper.innerHTML;

      this.$nextTick(() => {
        if (
          this.$refs.compareRef.clientWidth >
          this.$refs.contentWrapper.clientWidth
        ) {
          this.$refs.contentWrapper.setAttribute(
            "title",
            this.$refs.contentWrapper.innerHTML
          );
        }
      });
    });
  }
};
</script>

<style>
.component--tag {
  overflow: hidden;
  position: relative;
}

.component--tag .compare-ref-class {
  position: absolute;
  top: 120%;
}

.component--tag .content-wrapper {
  overflow: hidden;
  display: inline-block;
  text-overflow: ellipsis;
}

.component--tag .el-tag__close.el-icon-close {
  top: -11px;
}
</style>
